import React from "react";
import FileLibrary from "@/components/FileLibrary";
import { useI18n } from "@/lib/i18n";

export default function FilesPage() {
  const { t } = useI18n();
  return (
    <div className="px-4 py-6 sm:p-6 md:p-10 xl:p-12 max-w-7xl">
      <div className="mb-10">
        <div className="kicker mb-3">— {t("files_title")}</div>
        <h1 className="font-serif text-4xl md:text-5xl mb-3">{t("files_title")}</h1>
        <p className="text-[var(--td-text-2)] max-w-2xl leading-relaxed">{t("files_intro")}</p>
      </div>
      <FileLibrary />
    </div>
  );
}
